<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-textarea-input [control]="control" [disabled]="disabled" #input [label]="label" [labelI18NParams]="labelI18NParams"
                             [(ngModel)]="value" *ngSwitchDefault
                             (focussed$)="onFocussed($event)" [notation]="notation" [placeholder]="placeholder">
        <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
    </fui-edit-textarea-input>
    <fui-filter-textarea-input [disabled]="disabled" #input [(ngModel)]="value" [placeholder]="placeholder"
                               (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.FILTER">
        <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
    </fui-filter-textarea-input>
    <fui-inline-textarea-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value" *ngSwitchCase="contextType.INLINE"
                               (focussed$)="onFocussed($event)" [placeholder]="placeholder">
        <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
    </fui-inline-textarea-input>
    <fui-textarea-pill [disabled]="disabled" #input [(ngModel)]="value" *ngSwitchCase="contextType.PILL"
                       (focussed$)="onFocussed($event)" [placeholder]="placeholder"></fui-textarea-pill>
</ng-container>
